import {LobbyImage, TimeoutId} from '@colonist/types'
import {TranslationObject} from '@colonist/i18n'
import {MatchmakingStatusUpdate} from '../../../../../../../../shared/matchmaking/MatchmakingInterfaces'
import {TimeUtils} from '../../../../../../../../shared/utils/TimeUtils'
import {createButtonIn, createDivIn, createHeaderIn, createImgIn, createParagraphIn, setElementInnerHTML} from '../../../../../../../shared/scripts/ui_utils/DomUtils'
import {UIMFullscreenPageView} from '../../../../../ui_page/UIMFullscreenPageView'
import {GameTypeEnum, UIMMatchmakingController} from './UIMMatchmakingController'
import {uiManager} from '../../../../../EntryMobile'
import {socket} from '../../../../../../../shared/scripts/EntryShared'

export class UIMMatchmakingSearchingView extends UIMFullscreenPageView {
    private readonly searchingTitle: TranslationObject
    private readonly imageSrc: LobbyImage
    private readonly loadingText: TranslationObject
    private cancelButton: HTMLButtonElement

    protected currentCountElement: HTMLElement
    protected placementText: TranslationObject = {key: 'strings:colonistCommon.utils.emptyString'}
    protected titleContainer: HTMLDivElement
    protected timeElapsed: number = 0
    protected timeElapsedElement: HTMLDivElement
    protected timeElapsedInterval: TimeoutId

    readonly matchmakingController: UIMMatchmakingController

    constructor(matchmakingController: UIMMatchmakingController, title: TranslationObject, imageSrc: LobbyImage, loadingText: TranslationObject, isRanked: boolean, gameType: GameTypeEnum) {
        super({key: 'strings:colonistCommon.utils.emptyString'}, 'm-matchmaking-searching', () => undefined, 'matchmaking-searching-body')
        this.build()
        this.matchmakingController = matchmakingController
        this.searchingTitle = title
        this.imageSrc = imageSrc
        this.loadingText = loadingText
        this.header.backButton.style.display = 'none'

        this.updatePlacementText(isRanked, gameType)

        this.showSearchingView()
        socket.controller.registerSocketCloseObserver(() => this.matchmakingController.stopSearching())
    }

    hide() {
        super.hide()
        clearInterval(this.timeElapsedInterval)
    }

    removeFromDOM(): void {
        super.removeFromDOM()
        clearInterval(this.timeElapsedInterval)
    }

    showSearchingView() {
        this.addTitle()
        this.addImage()
        void this.addContent()
        this.createCancelButton()
        this.show()
    }

    show() {
        super.show()
        uiManager.adController.showBannerAds()
    }

    addTitle() {
        const divElement = createDivIn(this.body, 'm-matchmaking-search-header')
        this.titleContainer = createHeaderIn(divElement, this.loadingText, 'm-matchmaking-content', undefined, 'h2')
        this.currentCountElement = createHeaderIn(divElement, {key: 'strings:colonistCommon.utils.#buffer', options: {value: '...'}}, 'm-matchmaking-content', undefined, 'h2')
        const blankTime = '0:00'
        this.timeElapsedElement = createParagraphIn(divElement, {key: 'strings:homePage.matchmakingPopup.timeElapsed', options: {time: blankTime}}, 'm-matchmaking-content')
    }

    addImage() {
        const divElement = createDivIn(this.body, 'm-matchmaking-search-image')
        createImgIn(divElement, this.imageSrc, 'm-gamemode-img')
        createImgIn(divElement, LobbyImage.MatchmakingSearch, 'm-gamemode-search-icon')
    }

    async addContent() {
        const divElement = createDivIn(this.body, 'm-matchmaking-search-content')
        createHeaderIn(divElement, this.searchingTitle, 'm-matchmaking-content', undefined, 'h2')
        createParagraphIn(divElement, this.placementText, 'm-matchmaking-content')
    }

    createCancelButton() {
        this.cancelButton = createButtonIn(this.body, 'button_cta_sub', {key: 'strings:colonistCommon.utils.emptyString'})
        createHeaderIn(this.cancelButton, {key: 'strings:colonistCommon.buttons.cancel'}, 'm-outlined', undefined, 'h2')

        this.cancelButton.onclick = () => this.matchmakingController.stopSearching()
    }

    updateStatus(matchmakingStatusUpdate: MatchmakingStatusUpdate) {
        this.cancelButton.disabled = false
        const text: TranslationObject = {key: 'strings:colonistCommon.utils.#buffer', options: {value: `(${matchmakingStatusUpdate.numberOfPlayersFound}/${matchmakingStatusUpdate.totalNumberOfPlayersNeeded})`}}
        setElementInnerHTML(this.currentCountElement, text)
    }

    updatePlacementText(isRanked: boolean, gameType: GameTypeEnum) {
        this.placementText = {key: 'strings:homePage.matchmakingPopup.playAgainstSimilarKarma'}
        if(!isRanked) return

        this.placementText = this.matchmakingController.matchmakingActionsController.getRankedPlacementText(gameType) ?? this.placementText
    }

    protected setTimeElapsedCounter() {
        this.timeElapsed = 0
        this.timeElapsedInterval = setInterval(() => {
            this.timeElapsed += 1
            const newTimeString = TimeUtils.formatSecondsToElapsedString(this.timeElapsed)
            setElementInnerHTML(this.timeElapsedElement, {key: 'strings:homePage.matchmakingPopup.timeElapsed', options: {time: newTimeString}})
        }, 1000)
    }

    buildView(): void {
        void this
    }
}
